import React, { useState, Fragment, useEffect } from "react";
import { displayDateFormatter } from "components/helpers";

import EditIcon from "@material-ui/icons/Edit";
import {
  TextField,
  IconButton,
  CircularProgress,
  Snackbar,
  Alert,
  Button,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Autocomplete,
  Divider,
} from "@mui/material";
import { useUserData } from "components/customHooks/userDataContext";
import ReassingModal from "components/modals/ReassingModal";
import ShowText from "components/modals/ShowText";
import DictationOnHoldModal from "components/modals/dictationOnHold";
import ButtonProgress from "components/ButtonProgress";
import useSnackbar from "components/customHooks/useSnackbar";
import PrintIcon from "@material-ui/icons/Print";
import {
  getDictationNotes,
  getNoteTemplatesByPractice,
  getNoteCategoryByPractice,
  updateDictationNotes,
  getDiagnosisByDescription,
  getProceduresByDescription,
  updateEncounterDetails,
  getDictationDetails,
  updateDictationStatus,
  updateDictationDetails,
  uploadDictatioProvider,
  generateDictationPDF,
  getPatientList,
} from "apiHandler/actions";
import { Typography } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import PersonalInfoPlayer from "./PersonalInfoPlayer";
import utc from "dayjs/plugin/utc";
import DocumentViewer from "components/modals/claimDetails/documentViewer";
import { printDictationPDF } from "utils/helper";
import StatusBlock from "./statusBlock";
import StatusProgressBar from "components/UI/statusProgressBar";

dayjs.extend(utc);

const PersonalInfo = ({
  provider_name,
  details,
  encounter_id,
  setEncounterId,
  setDetails,
  readOnly,
  setSuggDiag,
  setSuggProce,
  npi,
  id,
  practice_id,
  setLoading,
}) => {
  const [previousMessages, setPreviousMessages] = useState(null);
  const [currentPlaying, setCurrentPlaying] = useState(null);
  const [editName, setEditName] = useState(false);
  const [loadingPrint, setLoadingPrint] = useState(null);
  const [editTitle, setEditTitle] = useState(false);
  const [notes, setNotes] = useState(null);
  // const [open, setOpen] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [notesError, setNotesError] = useState("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [notesTemplates, setNotesTemplates] = useState(["SOAP"]);

  const [selectedNoteTemplate, setSelectedNoteTemplate] = useState("SOAP");
  const [categories, setCategories] = useState([
    "Subjective",
    "Objective",
    "Assessment",
    "Plan",
  ]);
  const { CustomSnackbar, setSnackbarMessage } = useSnackbar();
  const [patientMode, setPatientMode] = useState("search"); // search | create
  const [patientSearchText, setPatientSearchText] = useState("");
  const [patientOptions, setPatientOptions] = useState([]);
  const [patientSearchLoading, setPatientSearchLoading] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);

  const [personalInfo, setPersonalInfo] = useState({
    patient_id: details?.patient_id || "",
    first_name: details?.first_name || "",
    last_name: details?.last_name || "",
    dob: details?.dob || null,
    isSaved: Boolean(details?.first_name && details?.last_name && details?.dob),
    title: details?.title || "",
    headline: details?.headline || "",
  });

  const [showText, setShowText] = useState(false);

  const [reassignModal, setReassingModal] = useState(false);
  const [showOnHold, setShowOnHold] = useState(false);
  const [isReopening, setIsReopening] = useState(false);
  const [reprocessing, setReprocessing] = useState(false);
  const [fetchedNotes, setFetchedNotes] = useState(null);
  const [reprocessMessage, setReprocessMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarMes, setSnackbarMes] = useState("");
  const [documentUrl, setDocumentUrl] = useState(null);
  const [openDocDialog, setOpenDocDialog] = useState(false);

  const [status, setStatus] = useState(details.status);
  const [scribingStatus, setScribingStatus] = useState(
    details.scribing_status || "Not Started",
  );
  const [codestatus, setCodeStatus] = useState(
    details.coding_review_status || "Not Started",
  );
  const [commentEditMode, setCommentEditMode] = useState(false);
  const [comment, setComment] = useState(details.comments || "");

  const userData = useUserData();

  const token = userData?.access_token;

  useEffect(() => {
    if (!editName || patientMode !== "search") return;

    const timer = setTimeout(() => {
      searchPatients(patientSearchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [patientSearchText, editName, patientMode]);

  useEffect(() => {
    fetchNotes();
  }, []);

  const onSelect = async () => {
    const response = await getNoteCategoryByPractice(
      {
        type: "Notes",
        search_criteria: {
          practice_id: practice_id,
          template_name: selectedNoteTemplate,
        },
      },
      token,
    );
    if (response) {
      let temp = {};
      await setCategories(
        response.map((c) => {
          if (!c.note_sub_categories) temp[c.note_category] = "";
          else
            temp[c.note_category] =
              "<p><strong>" +
              c.note_sub_categories
                .split(", ")
                .join("</strong></p><p><br></p><p><br></p><p><strong>") +
              "</strong></p>";
          return c.note_category;
        }),
      );
      setNotes(temp);
      setNotesTemplates([selectedNoteTemplate]);
    }
  };

  const updateNotes = async (payload, assessment, subjective) => {
    let encounter = encounter_id;
    if (!encounter) encounter = await updateEncounterInfo();
    await updateDictationNotes(payload, token);
    // await setEditModal(false);
    fetchNotes();
    await setLoading(true);
    if (assessment) {
      let data = {
        type: "Diagnosis",
        search_criteria: {
          practice_id,
          encounter_id: encounter,
          dictation_id: id,
          notes_description: assessment
            .replace(/<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>/g, "")
            .replace(/<[^]li>|<[^>]+>/g, ";")
            .replace(/;;/g, ";")
            .split(";")
            .filter((a) => a),
        },
      };
      const diagCodes = await getDiagnosisByDescription(data);
      await setSuggDiag(diagCodes && diagCodes !== "ERROR" ? diagCodes : []);
    }
    if (subjective) {
      let data = {
        type: "Procedure",
        search_criteria: {
          practice_id,
          encounter_id,
          dictation_id: id,
          npi: npi,
          notes_description: subjective
            .replace(/<strong>|<\/strong>|<em>|<\/em>|<u>|<\/u>/g, "")
            .replace(/<[^]li>|<[^>]+>/g, ";")
            .replace(/;;/g, ";")
            .split(";")
            .filter((x) => x),
        },
      };
      const proceCodes = await getProceduresByDescription(data);
      await setSuggProce(
        proceCodes && proceCodes !== "ERROR" ? proceCodes : [],
      );
    }
    await setLoading(false);
  };

  const fetchNotes = async () => {
    const payload = {
      type: "Dictation",
      search_criteria: {
        dictation_id: id,
        practice_id: practice_id,
        encounter_id,
        npi: npi,
      },
    };
    const response = await getDictationNotes(payload, token);
    console.log(response, "response");
    if (Array.isArray(response)) {
      if (response.length === 0) {
        const tempResponse = await getNoteTemplatesByPractice(
          {
            type: "Notes",
            search_criteria: {
              practice_id: practice_id,
            },
          },
          token,
        );
        await setNotesTemplates(tempResponse?.template_names || ["SOAP"]);
        if (tempResponse?.template_names?.length === 1) {
          await setSelectedNoteTemplate(
            tempResponse?.template_names?.[0] || "SOAP",
          );
          await setNotes({});
          await onSelect();
        }
      } else {
        let tempNotes = {};
        setCategories(
          response.map((r) => {
            tempNotes[r.note_category] = r.note_text;
            return r.note_category;
          }),
        );
        setNotes(tempNotes);
        setFetchedNotes(response);
      }
    } else {
      setNotesError(`Failed to get patient notes: ${response?.error}`);
      setNotes({});
    }
  };

  const updateEncounterInfo = async () => {
    const { id, npi } = details;
    const { patient_id, first_name, last_name, dob } = personalInfo;

    let record_data = {
      practice_id: practice_id,
      npi: npi,
      dictation_id: id,
      scribe_id: userData.email,
      last_updated_by: `${userData.first_name} ${userData.last_name}`,
      dos: details.dos,
      provider_name: `${details.provider_first_name} ${details.provider_last_name}`,
    };

    if (encounter_id) {
      record_data.encounter_id = encounter_id;
    }

    if (patientMode === "search" && patient_id) {
      record_data.patient_id = patient_id;
    } else {
      if (!first_name || !last_name || !dob) {
        setSnackbarSeverity("error");
        setSnackbarMes("Please enter First Name, Last Name and DOB");
        setSnackbarOpen(true);
        return;
      }

      record_data.first_name = first_name;
      record_data.last_name = last_name;
      record_data.dob = dayjs(dob).format("MM/DD/YYYY");
    }

    const payload = {
      type: "Encounter",
      record_data,
    };

    const response = await updateEncounterDetails(payload, token);

    if (response !== "ERROR") {
      setEditName(false);
      setPersonalInfo((prev) => ({
        ...prev,
        isSaved: Boolean(
          patientMode === "search"
            ? patient_id
            : first_name && last_name && dob,
        ),
      }));

      if (response?.encounter_id) {
        setEncounterId(response.encounter_id);
      }

      setDetails((prev) => ({
        ...prev,
        patient_id: patient_id || prev.patient_id,
        first_name,
        last_name,
        dob,
      }));

      setSnackbarSeverity("success");
      setSnackbarMes("Patient details updated successfully");
      setSnackbarOpen(true);
    } else {
      setSnackbarSeverity("error");
      setSnackbarMes("Failed to update patient details");
      setSnackbarOpen(true);
    }
  };

  const updateTitleInfo = async () => {
    const { id } = details;
    const { title, headline } = personalInfo;
    let payload = {
      type: "Dictation",
      record_data: {
        practice_id: practice_id,
        dictation_id: id,
        title: title,
        headline: headline,
        user_name: userData.first_name + " " + userData.last_name,
      },
    };
    console.log(payload, "payload");
    if (encounter_id) payload["record_data"]["encounter_id"] = encounter_id;
    const response = await updateDictationDetails(payload, token);
    if (response !== "ERROR") {
      setEditTitle(false);
      setPersonalInfo({
        ...personalInfo,
      });
    }
  };

  const reprocessAI = async () => {
    setReprocessing(true);
    try {
      const { id, npi } = details;
      let payload = {
        type: "Dictation",
        practice_id: practice_id,
        dictation_id: id,
        npi: `${npi}`,
        reprocess_dictation: "Yes",
        dos: details.dos,
        user_name: userData.first_name + " " + userData.last_name,
      };
      let formData = new FormData();
      formData.append("request_json", JSON.stringify(payload));

      const res = await uploadDictatioProvider(formData, token);
      console.log("res: ", res);
      if (res && res?.status === "Success") {
        setReprocessMessage(
          "System will reprocess the dictation, please check the notes after approximately one minute.",
        );
      } else {
        setReprocessMessage("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setReprocessing(false);
    }
  };

  // const onComplete = async () => {
  //   setShowSubmit(true);
  // };

  const onReopen = async () => {
    setIsReopening(true);
    const { id } = details;
    const payload = {
      type: "Scribe",
      search_criteria: {
        scribe_id: userData.email,
        dictation_id: id,
        status: "In-Progress",
        user_name: userData.first_name + " " + userData.last_name,
      },
    };
    const response = await updateDictationStatus(payload, token);
    if (response !== "ERROR") setDetails({ ...details, status: "In-Progress" });
    setIsReopening(false);
  };

  const handleChange = async (event) => {
    setStatus(event.target.value);
    setDetails({ ...details, status: event.target.value });
    const payload = {
      type: "Scribe",
      search_criteria: {
        scribe_id: userData.email,
        dictation_id: id,
        status: event.target.value,
        user_name: userData.first_name + " " + userData.last_name,
      },
    };
    try {
      await updateDictationStatus(payload, token);
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const handleStatusChange = async (event, type) => {
    const value = event.target.value;
    const loggedInUserName = `${userData.first_name} ${userData.last_name}`;
    if (type === "scribing") {
      setScribingStatus(event.target.value);
    }
    if (type === "coding") {
      setCodeStatus(event.target.value);
    }
    setDetails({
      ...details,
      ...(type === "scribing" && { scribing_status: event.target.value }),
      ...(type === "coding" && { coding_review_status: event.target.value }),
    });
    const payload = {
      type: "Dictation",
      record_data: {
        practice_id: practice_id,
        dictation_id: id,
        user_name: userData.first_name + " " + userData.last_name,
        ...(type === "scribing" && { scribing_status: event.target.value }),
        ...(type === "coding" && { coding_review_status: event.target.value }),
        ...(type === "scribing" &&
          value === "Completed" && {
            resource_id_scribing: loggedInUserName,
          }),

        ...(type === "coding" &&
          value === "Completed" && {
            resource_id_coding: loggedInUserName,
          }),
      },
    };
    try {
      await updateDictationDetails(payload, token);
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getDocument = async () => {
    setSnackbarSeverity("info");
    setSnackbarMes("Getting Document...");
    setSnackbarOpen(true);
    try {
      const payload = {
        practice_id: practice_id,
        dictation_id: id.toString(),
      };

      const blob = await generateDictationPDF(payload, token);
      const mimeType = blob.type || "application/octet-stream";
      const url = URL.createObjectURL(blob);

      setDocumentUrl({ url, mimeType });
      setOpenDocDialog(true);
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const handlePrintSummary = async () => {
    setLoadingPrint(true);
    try {
      const { id } = details;
      const payload = {
        type: "Dictation",
        search_criteria: {
          practice_id: practice_id,
          dictation_id: id.toString(),
        },
      };
      const dictationDetailResponse = await getDictationDetails(payload, token);
      if (dictationDetailResponse && dictationDetailResponse.length > 0) {
        const data = dictationDetailResponse.map((detail) => ({
          practice_details: detail.practice_details,
          patient_details: detail.patient_details,
          notes: detail.notes,
          dos: details.dos,
        }));

        printDictationPDF(data, userData);

        setLoadingPrint(false);
      } else {
        setSnackbarMessage("Dictation Details Not Found");
      }
    } catch (error) {
      console.log("error: ", error);
      setSnackbarMessage("Failed to get Dictation Details. Please try again!");
    } finally {
      setLoadingPrint(false);
    }
  };

  const onEditFirstName = (e) => {
    const value = e.target.value;
    setPersonalInfo((prev) => ({
      ...prev,
      patient_id: "",
      first_name: value,
    }));
    setDetails((prev) => ({
      ...prev,
      patient_id: "",
      first_name: value,
    }));
  };

  const onEditLastName = (e) => {
    const value = e.target.value;
    setPersonalInfo((prev) => ({
      ...prev,
      patient_id: "",
      last_name: value,
    }));
    setDetails((prev) => ({
      ...prev,
      patient_id: "",
      last_name: value,
    }));
  };

  const onEditDob = (e) => {
    setPersonalInfo((prev) => ({
      ...prev,
      patient_id: "",
      dob: e,
    }));
    setDetails((prev) => ({
      ...prev,
      patient_id: "",
      dob: e,
    }));
  };

  const handleCloseDocDialog = () => {
    setOpenDocDialog(false);
    if (documentUrl?.url && documentUrl?.url.startsWith("blob:")) {
      URL.revokeObjectURL(documentUrl.url);
    }
    setDocumentUrl(null);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleSaveComment = async () => {
    try {
      const payload = {
        type: "Dictation",
        record_data: {
          practice_id,
          dictation_id: id,
          comments: comment,
          user_name: `${userData.first_name} ${userData.last_name}`,
        },
      };

      const res = await updateDictationDetails(payload, token);
      if (res !== "ERROR") {
        setDetails({ ...details, comments: comment });
        setCommentEditMode(false);
        setSnackbarSeverity("success");
        setSnackbarMes("Comment updated successfully");
        setSnackbarOpen(true);
      } else {
        throw new Error("Failed to update comment");
      }
    } catch (error) {
      console.log("error: ", error);
      setSnackbarSeverity("error");
      setSnackbarMes("Failed to update comment");
      setSnackbarOpen(true);
    }
  };

  const openTranscribedText = () => {
    if (!details?.dictation_text) {
      setSnackbarSeverity("info");
      setSnackbarMes(
        "Transcribed text not found, Please click on Reprocess AI and try again!",
      );
      setSnackbarOpen(true);
    }
    setShowText(true);
  };

  const searchPatients = async (searchText) => {
    if (!searchText?.trim()) {
      setPatientOptions([]);
      return;
    }

    setPatientSearchLoading(true);
    try {
      const payload = {
        practice_id: String(practice_id),
        name: searchText.trim(),
      };

      const response = await getPatientList(payload, token);

      if (Array.isArray(response)) {
        setPatientOptions(response);
      } else if (Array.isArray(response?.data)) {
        setPatientOptions(response.data);
      } else {
        setPatientOptions([]);
      }
    } catch (error) {
      console.log("searchPatients error:", error);
      setPatientOptions([]);
    } finally {
      setPatientSearchLoading(false);
    }
  };

  const handlePatientSelect = (_, value) => {
    setSelectedPatient(value || null);

    if (value) {
      setPersonalInfo((prev) => ({
        ...prev,
        patient_id: value.patient_id || value.id || "",
        first_name: value.first_name || "",
        last_name: value.last_name || "",
        dob: value.dob || null,
      }));

      setDetails((prev) => ({
        ...prev,
        patient_id: value.patient_id || value.id || "",
        first_name: value.first_name || "",
        last_name: value.last_name || "",
        dob: value.dob || null,
      }));
    }
  };

  return (
    <>
      <div>
        <CustomSnackbar />

        <div
        //className="left"
        >
          <div className="dictation-notes">
            <div className="dictation-personal">
              <div className="right">
                <div className="text-audio">
                  {userData?.selected_practice === "1321" && (
                    <>
                      <button className="button" onClick={getDocument}>
                        Clinical Note
                      </button>
                      <Typography alignSelf="center" ml={1} fontSize={20}>
                        |
                      </Typography>
                    </>
                  )}
                  <IconButton onClick={() => handlePrintSummary()}>
                    {loadingPrint ? (
                      <CircularProgress color="secondary" size={15} />
                    ) : (
                      <PrintIcon color="secondary" />
                    )}
                  </IconButton>
                  <Typography alignSelf="center" mr={1} fontSize={20}>
                    |
                  </Typography>
                  <button className="button" onClick={openTranscribedText}>
                    Transcribed Text
                  </button>
                  {details.audio_duration && (
                    <div className="flex-align-center">
                      <span className="duration">{details.audio_duration}</span>
                      <PersonalInfoPlayer
                        showPlayer={true}
                        id={details.id}
                        currentPlaying={currentPlaying}
                        setCurrentPlaying={setCurrentPlaying}
                        practice_id={details.practice_id}
                        npi={details.npi}
                        ext={details.file_extension}
                      />
                    </div>
                  )}
                </div>
                {/* <div className="status">
                  <span className="title">Status</span>
                  <span className="content">{details.status}</span>
                </div> */}
                {details.status === "Completed" || (
                  <div className="status-change">
                    <button
                      className="blank-hover-btn"
                      onClick={() => setReassingModal(true)}
                    >
                      Reassign
                    </button>
                    {/* <button
                      className="blank-hover-btn"
                      onClick={() => setShowOnHold(true)}
                    >
                      {details.status !== "On-Hold" ? "On Hold" : "Messages"}
                    </button> */}
                  </div>
                )}
                <div className="btn-cont">
                  {details.status === "Completed" && (
                    <button className="reopen-btn" onClick={onReopen}>
                      {isReopening ? (
                        <ButtonProgress size={16} color="#d91a5f" />
                      ) : (
                        "Reopen"
                      )}
                    </button>
                  )}

                  {/* <Tooltip
                    title={
                      disableSubmit && details.status !== "Completed"
                        ? "Fill first name, last name, date of birth to enable the button"
                        : ""
                    }
                  > */}
                  {/* <button
                      className={disableSubmit ? "disable" : "dict-submit"}
                      onClick={disableSubmit ? () => {} : onComplete}
                      disable={disableSubmit ? 1 : 0}
                    >
                      Complete
                    </button> */}

                  {/* </Tooltip> */}
                </div>
              </div>
            </div>
            <Button
              variant="outlined"
              sx={{ marginLeft: "10px", marginRight: "10px" }}
              onClick={reprocessAI}
            >
              {reprocessing ? (
                <ButtonProgress size={16} color="#d91a5f" />
              ) : (
                "Reprocess AI"
              )}
            </Button>
            <Typography color="red" sx={{ marginBottom: 2 }}>
              {reprocessMessage}
            </Typography>
            <StatusProgressBar status={status} />
            <StatusBlock
              details={details}
              status={status}
              scribingStatus={scribingStatus}
              codestatus={codestatus}
              onOverallChange={handleChange}
              onScribingChange={(e) => handleStatusChange(e, "scribing")}
              onCodingChange={(e) => handleStatusChange(e, "coding")}
            />
            <div className="note-main-container">
              <Fragment>
                {!editName ? (
                  <>
                    <div className="notes-cont">
                      <p className="notes-title">First Name</p>
                      <div className="notes-content">
                        <p>{personalInfo.first_name || "-"}</p>
                      </div>
                    </div>

                    <div className="notes-cont">
                      <div>
                        <p className="notes-title">
                          Last Name
                          {readOnly || (
                            <EditIcon
                              fontSize="small"
                              color="secondary"
                              onClick={() => {
                                setEditName(true);
                                setPatientMode(
                                  details?.patient_id ? "search" : "create",
                                );
                                setSelectedPatient(
                                  details?.patient_id
                                    ? {
                                        patient_id: details.patient_id,
                                        first_name: details.first_name,
                                        last_name: details.last_name,
                                        dob: details.dob,
                                      }
                                    : null,
                                );
                              }}
                              style={{ marginLeft: 20, cursor: "pointer" }}
                            />
                          )}
                        </p>
                      </div>
                      <div className="notes-content">
                        <p>{personalInfo.last_name || "-"}</p>
                      </div>
                    </div>

                    <div className="notes-cont">
                      <p className="notes-title">DOB</p>
                      <div className="notes-content">
                        <p>
                          {personalInfo.dob
                            ? dayjs.utc(personalInfo.dob).format("MM/DD/YYYY")
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </>
                ) : (
                  <Box sx={{ width: "100%", p: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 1, fontWeight: 700 }}
                    >
                      Patient Selection
                    </Typography>

                    <RadioGroup
                      row
                      value={patientMode}
                      onChange={(e) => {
                        setPatientMode(e.target.value);
                        setSelectedPatient(null);
                        setPatientOptions([]);
                        setPatientSearchText("");
                        setPersonalInfo((prev) => ({
                          ...prev,
                          patient_id: "",
                          first_name: "",
                          last_name: "",
                          dob: null,
                        }));
                      }}
                    >
                      <FormControlLabel
                        value="search"
                        control={<Radio />}
                        label="Search Existing Patient"
                      />
                      <FormControlLabel
                        value="create"
                        control={<Radio />}
                        label="Create New Patient"
                      />
                    </RadioGroup>

                    <Divider sx={{ my: 2 }} />

                    {patientMode === "search" ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <Autocomplete
                          options={patientOptions}
                          value={selectedPatient}
                          onChange={handlePatientSelect}
                          inputValue={patientSearchText}
                          onInputChange={(_, newInputValue) => {
                            setPatientSearchText(newInputValue);
                          }}
                          loading={patientSearchLoading}
                          getOptionLabel={(option) =>
                            `${option.first_name || ""} ${option.last_name || ""}${
                              option.dob
                                ? ` - ${dayjs(option.dob).format("MM/DD/YYYY")}`
                                : ""
                            }`
                          }
                          isOptionEqualToValue={(option, value) =>
                            (option.patient_id || option.id) ===
                            (value.patient_id || value.id)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Search Patient"
                              placeholder="Enter patient name"
                              size="small"
                              fullWidth
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {patientSearchLoading ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={18}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                          renderOption={(props, option) => (
                            <Box component="li" {...props}>
                              <Box>
                                <Typography fontWeight={600}>
                                  {option.first_name} {option.last_name}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  DOB:{" "}
                                  {option.dob
                                    ? dayjs(option.dob).format("MM/DD/YYYY")
                                    : "-"}
                                  {" | "}Patient ID:{" "}
                                  {option.patient_id || option.id || "-"}
                                </Typography>
                              </Box>
                            </Box>
                          )}
                        />

                        {selectedPatient && (
                          <Box
                            sx={{
                              p: 1.5,
                              border: "1px solid #e0e0e0",
                              borderRadius: 2,
                              backgroundColor: "#fafafa",
                            }}
                          >
                            <Typography variant="body2">
                              <strong>Selected Patient:</strong>{" "}
                              {selectedPatient.first_name}{" "}
                              {selectedPatient.last_name}
                            </Typography>
                            <Typography variant="body2">
                              <strong>DOB:</strong>{" "}
                              {selectedPatient.dob
                                ? dayjs(selectedPatient.dob).format(
                                    "MM/DD/YYYY",
                                  )
                                : "-"}
                            </Typography>
                            <Typography variant="body2">
                              <strong>Patient ID:</strong>{" "}
                              {selectedPatient.patient_id ||
                                selectedPatient.id ||
                                "-"}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <TextField
                          label="First Name"
                          value={personalInfo.first_name}
                          onChange={onEditFirstName}
                          size="small"
                          fullWidth
                        />
                        <TextField
                          label="Last Name"
                          value={personalInfo.last_name}
                          onChange={onEditLastName}
                          size="small"
                          fullWidth
                        />
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                            label="DOB"
                            format="MM/DD/YYYY"
                            value={
                              personalInfo.dob ? dayjs(personalInfo.dob) : null
                            }
                            onChange={onEditDob}
                            maxDate={dayjs()}
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Box>
                    )}

                    <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
                      <Button variant="contained" onClick={updateEncounterInfo}>
                        Save
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setEditName(false);
                          setPatientMode("search");
                          setSelectedPatient(null);
                          setPatientSearchText("");
                          setPatientOptions([]);
                          setPersonalInfo((prev) => ({
                            ...prev,
                            patient_id: details?.patient_id || "",
                            first_name: details?.first_name || "",
                            last_name: details?.last_name || "",
                            dob: details?.dob || null,
                          }));
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Box>
                )}
              </Fragment>
            </div>
            <div className="note-main-container">
              <Fragment>
                <div className="notes-cont">
                  <p className="notes-title">Title</p>
                  <div className="notes-content">
                    {!editTitle ? (
                      <p>{personalInfo.title || "-"}</p>
                    ) : (
                      <TextField
                        placeholder="Title"
                        multiline
                        value={personalInfo.title}
                        onChange={(e) =>
                          setPersonalInfo({
                            ...personalInfo,
                            title: e.target.value,
                          })
                        }
                        style={{ marginRight: 10 }}
                      />
                    )}
                  </div>
                </div>
                <div className="notes-cont">
                  <div>
                    <p className="notes-title">
                      Headline
                      {!editTitle && (
                        <EditIcon
                          fontSize="small"
                          color="secondary"
                          onClick={() => setEditTitle(true)}
                          style={{ marginLeft: 20 }}
                        />
                      )}
                    </p>
                  </div>
                  <div className="notes-content">
                    {!editTitle ? (
                      <p>{personalInfo.headline || "-"}</p>
                    ) : (
                      <TextField
                        placeholder="Headline"
                        multiline
                        value={personalInfo.headline}
                        onChange={(e) =>
                          setPersonalInfo({
                            ...personalInfo,
                            headline: e.target.value,
                          })
                        }
                        style={{ marginRight: 10 }}
                      />
                    )}
                  </div>
                </div>
                {editTitle && (
                  <div className="notes-cont">
                    <button
                      className="blank-hover-btn"
                      onClick={updateTitleInfo}
                    >
                      Save
                    </button>
                    <button
                      className="blank-hover-btn"
                      style={{ marginLeft: 10, marginBottom: 10 }}
                      onClick={() => {
                        setEditTitle(false);
                        setPersonalInfo({
                          title: details.title,
                          headline: details.headline,
                        });
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </Fragment>
            </div>
            <div className="note-main-container">
              <div className="notes-cont">
                <p className="notes-title">Template Name</p>
                <div className="notes-content">
                  {details.template_name || "-"}
                </div>
              </div>
              <div className="notes-cont">
                <p className="notes-title">Template Display Name</p>
                <div className="notes-content">
                  {details.template_display_name || "-"}
                </div>
              </div>
            </div>
            <div className="note-main-container">
              <div className="notes-cont">
                <p className="notes-title">DOS</p>
                <div className="notes-content">{details.dos || "-"}</div>
              </div>
              <div className="notes-cont">
                <p className="notes-title">Doctor</p>
                <div className="notes-content">{provider_name || "-"}</div>
              </div>
            </div>
            <div className="note-main-container">
              <div className="notes-cont">
                <p className="notes-title">Submitted on</p>
                <div className="notes-content">
                  {details.updated_date || "-"}
                </div>
              </div>
              <div className="notes-cont">
                <p className="notes-title">Last Updated</p>
                <div className="notes-content">
                  {displayDateFormatter(details.updated_date) || "-"}
                </div>
              </div>
              <div className="notes-cont">
                <p className="notes-title">
                  Comments
                  {!commentEditMode && (
                    <EditIcon
                      fontSize="small"
                      color="secondary"
                      onClick={() => setCommentEditMode(true)}
                      style={{ marginLeft: 20, cursor: "pointer" }}
                    />
                  )}
                </p>
                <div className="notes-content">
                  {!commentEditMode ? (
                    <p>{comment || "-"}</p>
                  ) : (
                    <>
                      <TextField
                        multiline
                        minRows={2}
                        maxRows={4}
                        fullWidth
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        size="small"
                        variant="standard"
                        style={{ marginRight: 10 }}
                      />
                      <div style={{ marginTop: 8 }}>
                        <button
                          className="blank-hover-btn"
                          onClick={handleSaveComment}
                          style={{ marginRight: 8 }}
                        >
                          Save
                        </button>
                        <button
                          className="blank-hover-btn"
                          onClick={() => {
                            setCommentEditMode(false);
                            setComment(details.comments || "");
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {showText && details?.dictation_text && (
          <ShowText
            text={details.dictation_text}
            onClose={() => setShowText(false)}
            showPlayer={true}
            id={details.id}
            details={details}
            currentPlaying={currentPlaying}
            setCurrentPlaying={setCurrentPlaying}
            practice_id={details.practice_id}
            npi={details.npi}
            ext={details.file_extension}
            encounter_id={encounter_id}
            categories={categories}
            savedNotes={notes}
            updateNotes={updateNotes}
            fetchedNotes={fetchedNotes}
          />
        )}

        {/* {showSubmit && (
          <SubmitModal
            id={details.id}
            onClose={() => setShowSubmit(false)}
            details={details}
            setDetails={setDetails}
          />
        )} */}
        {reassignModal && (
          <ReassingModal
            id={details.id}
            onClose={() => setReassingModal(false)}
          />
        )}
        {showOnHold && (
          <DictationOnHoldModal
            dictation_id={details.id}
            details={details}
            setDetails={setDetails}
            onClose={() => setShowOnHold(false)}
            previous={previousMessages}
            setPrevious={setPreviousMessages}
            onHold={details.status === "On-Hold"}
          />
        )}

        <DocumentViewer
          openDocDialog={openDocDialog}
          documentUrl={documentUrl}
          handleCloseDocDialog={handleCloseDocDialog}
        />
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={4000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMes}
          </Alert>
        </Snackbar>
      </div>
      {/* {printPage &&
        printPage.map((params, i) => <DictationSummary params={params} />)} */}
    </>
  );
};

export default PersonalInfo;
